import axios from '../../../axios'

export const getWoRepairStat = (data) => {
  return axios({
    url: '/stat/woRepair/getWoRepairStat',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/biz/stat/statWoRepair.js